<template>
    <div v-if="showApp">
        <page-configuration></page-configuration>
    </div>
</template>

<script>

import PageConfiguration from "@/projects/configuration/component/page-home.vue";

export default {
    data() {
        return {
            showApp: false,
        };
    },
    mounted() {
        let appsToShow = this.$store.state.webApplicationToShow;
        let currentApp = this.$route.fullPath.replace("/", "").split('?')[0];
        if (appsToShow.includes(currentApp)) this.showApp = true;
    },
    components: {
        PageConfiguration,
    },
};
</script>

<style></style>
